<template>
  <div>
    <div v-if="folios.length === 0">
      <b-notification
        class="ml-4"
        type="is-info is-light"
        has-icon
        :closable="false"
      >
        <strong>
          No se han completado folios para este recuento de inventario
        </strong>
      </b-notification>
    </div>
    <div v-else class="columns folio-body">
      <comparador-folio
        v-for="(item, index) in folios"
        :key="`folio-item-${item.id}-${index}`"
        :folio="item"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ComparadorFolio from '@/components/comparador-v2/ComparadorFolio'

export default {
  name: 'ComparadorFolios',
  components: { ComparadorFolio },
  props: {
    recuento: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('comparador', ['folios', 'scrollX'])
  },
  watch: {
    scrollX(newValue) {
      if (newValue.source !== 'body') {
        document.getElementsByClassName('folio-body')[0].scrollLeft =
          newValue.scrollLeft
      }
    },
    folios(newValue) {
      if (newValue && newValue.length > 0) {
        this.showScroll = true
        this.$nextTick(() =>
          document
            .getElementsByClassName('folio-body')[0]
            .addEventListener('scroll', this.bodyScrollHandle)
        )
      } else {
        if (document.getElementsByClassName('folio-body').length > 0)
          document
            .getElementsByClassName('folio-body')[0]
            .removeEventListener('scroll', this.bodyScrollHandle)
        this.$nextTick(() => (this.showScroll = false))
      }
    }
  },
  destroyed() {
    const listeners = document.getElementsByClassName('folio-body')
    if (listeners.length > 0)
      listeners[0].removeEventListener('scroll', this.bodyScrollHandle)
  },
  methods: {
    bodyScrollHandle(evt) {
      this.$store.commit('comparador/SET_SCROLL_HORIZONTAL', {
        scrollLeft: evt.target.scrollLeft,
        source: 'body'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.is-vcentered {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.item-wrapper {
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item-code {
    font-weight: 700;
  }
  .item-description {
    font-size: 0.85rem;
  }
}
.column {
  padding: 0.5rem;
}
</style>
